import React from 'react'
import Icon from '../Icon/Icon'
import { Constants } from 'app/app/(client)/utils/client-constants'

interface NotificationDotProps {
  count: number
  variant?: 'desktop' | 'mobile'
  className?: string
}

const NotificationDot: React.FC<NotificationDotProps> = ({ count, variant = 'desktop', className = '' }) => {
  const isMobileVariant = variant === 'mobile'

  const baseClasses = 'text-white rounded-full flex items-center justify-center leading-[18px]'

  const desktopStyle =
    'absolute -top-1 -right-1 sm:-top-1 sm:-right-1 md:-top-1 md:-right-1 z-10 text-[10px] sm:text-[11px] md:text-[12px] min-w-[14px] h-[14px] sm:min-w-[15px] sm:h-[15px] md:min-w-[16px] md:h-[16px]'

  const mobileStyle = 'min-w-[20px] h-[20px] text-[12px]'

  const bgColor = count > 0 ? 'bg-[var(--tint-red-500)]' : 'bg-[var(--tint-green-500)]'

  return (
    <span className={`${baseClasses} ${isMobileVariant ? mobileStyle : desktopStyle} ${bgColor} ${className}`}>
      {count > 0 ? (
        count > 9 ? (
          Constants.NINE_PLUS
        ) : (
          count.toString()
        )
      ) : (
        <Icon name="icon-check" className="text-white text-[10px] sm:text-[11px] md:text-[12px]" />
      )}
    </span>
  )
}

export default NotificationDot
